import { connect } from 'react-redux';

// Components
import AppointmentFlowWizard from './AppointmentFlowWizard';

// Selectors
import { showHeader } from 'store/reducers/dealerSettings/selectors';
import { getCTABanner } from 'store/reducers/optimizelyABTest/selectors';

const mapStateToProps = state => ({
  showHeader: showHeader(state),
  ctaBanner: getCTABanner(state)
});

export default connect(
  mapStateToProps,
  {}
)(AppointmentFlowWizard);



// WEBPACK FOOTER //
// ./src/components/templates/AppointmentFlowWizard/AppointmentFlowWizardContainer.js